import { useQuery } from "@tanstack/react-query";
import { rolesClient } from "@users/rolesClient";

export const rolesKeys = {
  list: (sessionKey: string) => ["roles", sessionKey] as const,
};

/**
 * Clinic roles, used to resolve a task's assigned-role uuid to a name.
 * Non-suspense and best-effort like `useClinicUsers`: a failed/slow roles
 * fetch must not block or crash a card that only wants an optional display
 * name.
 */
export const useClinicRoles = (sessionKey: string) =>
  useQuery({
    queryKey: rolesKeys.list(sessionKey),
    queryFn: () => rolesClient.list(),
  });
